import { createNamespacedHelpers } from 'vuex'
const { mapGetters: mapDicGetters, mapState: mapDicState } = createNamespacedHelpers('bis/dic')

const dicStates = [
  'users', 'terminals', 'components', 'organizations', 'processes', 'instruments', 'fees'
].reduce(function (result, item, index) {
  result['$$' + item] = item
  return result
}, {})

const dicGetters = [
  'usersOptions', 'userById', 'userNameById',
  'terminalsOptions', 'terminalById', 'terminalNameById',
  'componentsOptions', 'componentById', 'componentNameById', 'materialComponents', 'materialComponentsOptions',
  'organizationsOptions', 'organizationById', 'organizationNameById', 'departmentOrganizationsOptions',
  'processesOptions', 'processById', 'processNameById',
  'instrumentsOptions', 'instrumentById', 'instrumentNameById', 'feeById'
].reduce(function (result, item, index) {
  result['$$' + item] = item
  return result
}, {})

export default {
  created: async function () {
    await this.$store.dispatch('bis/dic/loadModels')
  },
  computed: {
    ...mapDicGetters(dicGetters),
    ...mapDicState(dicStates)
  }
}
